module.exports = require("./pl-PL");